import { HttpErrorResponse, HttpEvent, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '@environment';
import { ROUTES_MOCK } from './app-control.mock';
import { CUSTOMER_MOCK } from './data/customer';
import { PRE_CUSTOMER } from './data/pre-customer';

export class ServerMock {
  private _validationAttempts = 0;
  private _validationResponse = CUSTOMER_MOCK.VALIDATION_PENDING_DEFAULT;

  private _precustomersAttempts = 0;
  private _precustomersResponse = PRE_CUSTOMER.FAST_ONBOARDING_ENABLED_WITHOUT_DATA;

  public request(req: HttpRequest<any>): Observable<HttpEvent<any>> {
    const statusResponse = 200;
    //TODO: improve pending to change mocks dynamically

    if (req.url === '/app/customers/validation' && req.method === 'GET') {
      this._validationAttempts++;

      if (this._validationAttempts >= 4) {
        this._validationResponse = CUSTOMER_MOCK.VALIDATION_APPROVED_DEFAULT;
      }

      const response = new HttpResponse({
        status: statusResponse,
        body: this._validationResponse,
      });

      return new Observable((obs: any) => {
        setTimeout(() => {
          obs.next(response);
          obs.complete();
        }, environment.testServeWait);
      });
    }

    if (req.url === '/app/pre-customers' && req.method === 'GET') {
      this._precustomersAttempts++;

      if (this._precustomersAttempts >= 3) {
        this._precustomersResponse = PRE_CUSTOMER.FAST_ONBOARDING_ENABLED_WITH_DATA;
      }

      const response = new HttpResponse({
        status: statusResponse,
        body: this._precustomersResponse,
      });

      return new Observable((obs: any) => {
        setTimeout(() => {
          obs.next(response);
          obs.complete();
        }, environment.testServeWait);
      });
    }

    const response = ROUTES_MOCK.find(
      (route) =>
        new RegExp(route.url).test(req.url) && (!route.method || route.method === req.method)
    );

    if (!response) {
      const error = {
        status: 404,
        statusText: `The route was not found ${req.url}`,
      };
      return throwError(() => new HttpErrorResponse(error));
    }

    return new Observable((obs: any) => {
      setTimeout(() => {
        obs.next(new HttpResponse({ status: statusResponse, body: response.data }));
        obs.complete();
      }, environment.testServeWait);
    });
  }
}
